var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.getProtocolCreateFlag == true ? _c('div', {
    staticClass: "newProtocolWrap"
  }, [_vm.noneSelectProtocol == false ? _c('p', {
    staticClass: "txt"
  }, [_vm._v("현재 장비에 프로토콜이 없습니다.")]) : _vm._e(), _vm.noneSelectProtocol ? _c('p', {
    staticClass: "txt"
  }, [_vm._v("좌측 이슈리스트에서 프로토콜을 선택해주세요.")]) : _vm._e(), _vm.noneSelectProtocol == false ? _c('btn-link', {
    attrs: {
      "classType": "border-blue-plus"
    },
    on: {
      "click": _vm.cancelHandler
    }
  }, [_vm._v("프로토콜 추가하기")]) : _vm._e()], 1) : _c('div', {
    staticClass: "newProtocolWrapNoCreate"
  }, [_vm._m(0), _c('p', {
    staticClass: "txt"
  }, [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("※ 프로토콜 작성 후 재료, 목적, 장비를 선택하시려면 게이트웨이로 이동 후 프로토콜을 생성해 주세요.")])], 1)]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', {
    staticClass: "txt"
  }, [_c('b', [_vm._v("공정도에서 프로토콜을 생성하기 위해서는 재료, 목적, 장비가 모두 연결되어 있어야 됩니다.")])]);

}]

export { render, staticRenderFns }